import ApiServer from "../ApiServer.js";
import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as libLocation from "../lib/location.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";

function afterfamchange(){
  FwDatas.reset();
  FwDatas.setFamilies([]);
  //remove parameters of the page which depends on family and goto this page with the new one
  var 
    loc = libLocation.getLocation(),
    dotIdx = loc.indexOf('?');
  if(dotIdx>-1) loc = loc.substring(0,dotIdx);
  libLocation.goTo(loc,true,true);
}
export function changeTo(familyId){
  ApiServer.famlogfamily(familyId);
  ApiServer.famsetfirst(familyId,afterfamchange);
  amplify.publish("familyScopeChange");
  
}
Html.register({
  "changetofamily":function(familyid){
    changeTo(familyid);
  },
  "acceptinvitation":function(iid){
    ApiServer.famacceptinvitation(iid,afterfamchange);
  },
  "blockinvitation":function(iid){
    ApiServer.famblockinvite(iid,true,afterfamchange);
  },
  "cancelinvitation":function(iid){
    ApiServer.famcancelinvite(iid,afterfamchange);
  }
  
});
ApiServer["ui.acccreatefamily"] = async function(form,onSucces,onError){
  function doit(){
    ApiServer.acccreatefamily.prepare({cover:"/mediadefault/familyCover"},function(){
      FwDatas.reset();
      FwDatas.setFamilies([]);
      amplify.publish('familyScopeChange')
      libLocation.goTo(INR.URL.ENTER_HOME,true,true);
    },function(err){
      modal.closeModal();
      if(err.code==='505' && err.rightFlag==='KO_LIMIT'){
        Html.trigger('createcirclequotareached');
      }else{
        modal.alert('fw2.defaultError');
      }
    })(form,onSucces,onError); 
  }
  const newName = form.name.value.toLocaleUpperCase();
  if(FwDatas.getFamilies().some(fam=>fam.name.toLocaleUpperCase()===newName)){
    if(await modal.confirm({title:'errors.oops',message:'errors.duplicatefamilyname',yes:'actions.confirmandcreate',no:'actions.cancel',lottie:"images/lottie/face_with_monocle.json"})){
      doit();
    }
  }else{
    doit();  
  }
}